import React from 'react'
import { connect } from 'react-redux'
import className from "classnames";
import axios from 'axios'
import * as actions from "./../../actions";
import "./RemoveOccmDialog.css"
import ONTAPCloudLogo from "images/netapp-services/ontap-cloud.svg"
import Isvg from 'react-inlinesvg';

const DumbRemoveOccmDialog = ({closeDialog, removeOccmState, occm, removeOccm}) => {
    const wrappedRemove = () => {
        removeOccm(occm.occm).then(() => {
            closeDialog()
        })
    };
    return (<div>
            <h3>Remove Cloud Manager Listing</h3>
            <div className={className("dialog-content", {error: removeOccmState.status === actions.STATUS_ERROR})}>
                <p>Are you sure you want to remove this Cloud Manager listing?</p>
                <p>The Cloud Manager will be removed from your list of Cloud Managers, but the instance itself will remain.</p>
                <div className="occm-row">
                    <div className="logo"><Isvg src={ONTAPCloudLogo}/></div>
                    <div className="info" style={{width: occm.primaryCallbackUri ? "180px" : "385px"}}>
                        <div className="title">Name:</div>
                        <div className="text text-ellipsis">{occm.occmName}</div>
                    </div>
                    {occm.primaryCallbackUri && <div className="info" style={{width: "180px"}}>
                        <div className="title">Address:</div>
                        <div className="text text-ellipsis">{occm.primaryCallbackUri}</div>
                    </div>}
                </div>
            </div>
            {removeOccmState.status === actions.STATUS_ERROR &&
            <div className="error-text">
                Failed to remove: {removeOccmState.data.message}
            </div>
            }
            <div className="dialog-buttons">
                <button className="cancel medium right" onClick={closeDialog} disabled={removeOccmState.status === actions.STATUS_PENDING}>Cancel</button>
                <button className="secondary medium right" onClick={wrappedRemove} disabled={removeOccmState.status === actions.STATUS_PENDING}>{removeOccmState.status === actions.STATUS_PENDING ? "Removing..." : "Remove"}</button>
            </div>
        </div>
    )
};


const mapDispatchToProps = dispatch => {
    return {
        removeOccm: (occmId) => {
            const payload =  axios.post("/occm/deassociate-self", {
                occmId
            });

            dispatch({
                type: "REMOVE-OCCM",
                payload
            });

            return payload;
        }
    }
};

const mapStateToProps = state => {
    return {
        removeOccmState: state.services.removeOccmState || {}
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(DumbRemoveOccmDialog);


// WEBPACK FOOTER //
// ./src/components/launch-pad/RemoveOccmDialog.js